
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class ChallengeValuationEligibleStudentForm extends Form {
	private static _instance = new ChallengeValuationEligibleStudentForm();
	offeredSubjectId:Field = {
		name:'offeredSubjectId'
		,controlType: 'Hidden'
		,label: 'offeredSubjectId'
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};

	public static getInstance(): ChallengeValuationEligibleStudentForm {
		return ChallengeValuationEligibleStudentForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('offeredSubjectId', [Validators.max(9999999999999)]);
		this.fields.set('offeredSubjectId', this.offeredSubjectId);
		this.opsAllowed = {filter: true};
	}

	public getName(): string {
		 return 'challengeValuationEligibleStudent';
	}
}


export class ChallengeValuationEligibleStudentFd extends FormData {
	constructor(form: ChallengeValuationEligibleStudentForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'offeredSubjectId', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'offeredSubjectId' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface ChallengeValuationEligibleStudentVo extends Vo {
	studentId?: number, 
	offeredSubjectId?: number, 
	usn?: string, 
	level?: string, 
	name?: string, 
	instituteId?: number, 
	department?: string, 
	optedForChallenge?: boolean
}
